import { SprinklesElement } from "sprinkles-js";

export default class NavigatorShareElement extends SprinklesElement {
  static tagName = "navigator-share";
  static refs = ["trigger", "fallback"];
  static events = {
    click: { method: "shareThroughNavigator", ref: "trigger" },
  };
  static canShare =
    navigator.canShare && navigator.canShare({ url: "https://example.com" });

  afterConnected() {
    if (this.constructor.canShare) {
      this.refs.fallback.hidden = true;
      this.refs.trigger.hidden = false;
    }
  }

  shareThroughNavigator() {
    navigator.share({ url: this.dataset.url });
  }
}
